import { get } from 'lodash';
import React from 'react';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { hasAnyNachweisPositionComment } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import { KOSTEN_ARTEN, KOSTENTRAEGER, PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import InvestitionskostenUebersichtVNLIS from './InvestitionskostenUebersichtVNLIS';
import InvestitionsKostenVNLIS, { getFormStrucInvestitionsKostenVNLIS } from './InvestitionsKostenVNLIS';

// import schemas
import NachweisPositionSchema from '../../../../../../../lib/paths/nachweisposition_FULL_Paths.json';
import Schema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;
const NP_P = NachweisPositionSchema.attributes;

export const GetInvestitionskostenVNLIS = (application: any, kostenKategories: any[], readOnly: boolean) => {
	let nodeStruc: any[] = [];
	const standorte = get(
		application,
		P.Foerderantrag.schema.attributes.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Standort_Spezifikation_Ladeinfrastruktur.path,
		[]
	);
	if (standorte.length === 1) {
		const standortGroupID = get(standorte[0], 'Group_45_ID', null);
		nodeStruc = [
			{
				label: 'Investitionskosten',
				content: (
					<>
						<ApplicationHeading title='Investitionskosten' description={PLATZHALTER_TEXT} />
						<InvestitionsKostenVNLIS
							kostentraeger={KOSTENTRAEGER.Antragsteller}
							standortGroupId={standortGroupID}
							unternehmenId={get(getLocalstorageToken(), 'organisationId')}
							kostenKategories={kostenKategories}
						/>
					</>
				),
				formStruc: getFormStrucInvestitionsKostenVNLIS(
					application,
					KOSTENTRAEGER.Antragsteller,
					standortGroupID,
					get(getLocalstorageToken(), 'organisationId'),
					kostenKategories,
					readOnly
				),
				hasComment: hasAnyNachweisPositionComment(
					readOnly,
					application,
					P.Verwendungsnachweis_Nachweispositions.path,
					'KostenArt',
					0,
					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
					KOSTEN_ARTEN.Investitionskosten
				),
			},
			{
				label: 'Investitionskosten Übersicht',
				content: <InvestitionskostenUebersichtVNLIS />,
			},
		];
	} else if (standorte.length > 1) {
		const nodeStrucChildren = standorte.map((ele: any, index: number) => {
			return {
				label: get(ele, 'Strasse_Und_Hausnummer', `Standort ${index + 1}`),
				content: (
					<InvestitionsKostenVNLIS
						kostentraeger={KOSTENTRAEGER.Antragsteller}
						standortGroupId={get(ele, 'Group_45_ID', null)}
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						kostenKategories={kostenKategories}
					/>
				),
				formStruc: getFormStrucInvestitionsKostenVNLIS(
					application,
					KOSTENTRAEGER.Antragsteller,
					get(ele, 'Group_45_ID', null),
					get(getLocalstorageToken(), 'organisationId'),
					kostenKategories,
					readOnly
				),
			};
		});
		nodeStruc = [
			{
				label: 'Investitionskosten',
				content: <ApplicationHeading title='Investitionskosten' description={PLATZHALTER_TEXT} />,
				hasComment: hasAnyNachweisPositionComment(
					readOnly,
					application,
					P.Verwendungsnachweis_Nachweispositions.path,
					'KostenArt',
					0,
					NP_P.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenart_Finanzierung.path,
					KOSTEN_ARTEN.Investitionskosten
				),
				children: [...nodeStrucChildren],
			},
			{
				label: 'Investitionskosten Übersicht',
				content: <InvestitionskostenUebersichtVNLIS />,
			},
		];
	}

	return [...nodeStruc];
};
